"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoHeader = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./PromoHeader.css"));
var _UIHeading = require("@cian/ui-kit/typography/UI/UIHeading/UIHeading");
var _UIText = require("@cian/ui-kit/typography/UI/UIText/UIText");
var _Labels = require("../Labels");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PromoHeader = props => {
  const {
    authorName,
    promoName,
    authorLogo,
    labels
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: style['promo-header']
  }, authorLogo && /*#__PURE__*/React.createElement("img", {
    src: authorLogo,
    alt: authorName,
    className: style['author-logo']
  }), /*#__PURE__*/React.createElement("div", {
    className: style['promo-info']
  }, /*#__PURE__*/React.createElement(_UIText.UIText2, null, authorName), /*#__PURE__*/React.createElement(_UIHeading.UIHeading2, null, promoName), /*#__PURE__*/React.createElement(_Labels.Labels, {
    labels: labels
  })));
};
exports.PromoHeader = PromoHeader;